module.exports = __webpack_public_path__ + "img/file-earmark-bar-graph-fill.e2e8b7f8.svg";